import { graphql, useStaticQuery } from 'gatsby';
import React, { useState } from 'react';

import { css } from '@emotion/core';
import { findMatchingNodePath, getDropDownOptions } from '@helpers/scripts';
import { Box, Flex } from '@rebass/emotion';

import { FormInput, FormSelect } from './index';

interface FormDateGroupProps {
  value: '';
  name: string;
  setFieldValue: (name: string, value: {}) => void;
  setFieldError: (name: string, message: string) => void;
  setFieldTouched: (name: string, touched: boolean) => void;
  location: {
    pathname: string;
  };
}

const FormDateGroup = ({ value, name, setFieldValue, setFieldTouched }: FormDateGroupProps) => {
  const isNotRLS = location
    ? !location.pathname.includes('/participants/neurology/restless-legs-syndrome-study')
    : true;
  const [date, setDate] = useState({ day: '', month: 0, year: '' });
  const [selected, setSelected] = useState(false);
  const {
    allTrialsJson: { nodes },
  } = useStaticQuery(query);
  const { formDateGroup } = findMatchingNodePath(nodes, location).strings.form;
  const months = getDropDownOptions(formDateGroup.month.monthOptions);

  let month = null;
  let day = null;
  let year = null;

  const parseDate = () => {
    [year, month, day] = value.split('-');
    return year && month && month !== '0' && day && day !== '0';
  };

  if (isNotRLS && parseDate() && !selected) {
    [year, month, day] = value.split('-');
    month = parseInt(month, 10);
    setFieldValue(name, `${year}-${month}-${day}`).then(() => setFieldTouched(name, true));
    setDate({ day, month, year });
    setSelected(true);
  } else if (!isNotRLS && value && !selected) {
    setDate({ ...date, ['year']: value });
    setFieldValue(name, `${value}`).then(() => setFieldTouched(name, true));
    setSelected(true);
  }
  return (
    <div data-i="date-group">
      {isNotRLS ? (
        <Flex justifyContent="space-between">
          <FormSelect
            placeholder={formDateGroup.month.heading}
            name="month"
            onChange={(e: any) => {
              setDate({ ...date, ['month']: e.value });
              setFieldValue(name, `${date.year}-${e.value}-${date.day}`).then(() => setFieldTouched(name, true));
            }}
            options={months}
            value={date.month || ''}
          />
          <FormInput
            type="text"
            placeholder="DD"
            css={css`
              width: 80px;
              margin-left: 4%;
              margin-right: 4%;
            `}
            onChange={(e: any) => {
              setDate({ ...date, ['day']: e.target.value });
              setFieldValue(name, `${date.year}-${date.month}-${e.target.value}`).then(() =>
                setFieldTouched(name, true)
              );
            }}
            name="day"
            maxLength="2"
            value={date.day || ''}
          />
          <FormInput
            type="text"
            placeholder="YYYY"
            css={css`
              width: 50%;
            `}
            onChange={(e: any) => {
              setDate({ ...date, ['year']: e.target.value });
              setFieldValue(name, `${e.target.value}-${date.month}-${date.day}`).then(() =>
                setFieldTouched(name, true)
              );
            }}
            name="year"
            maxLength="4"
            value={date.year || ''}
          />
        </Flex>
      ) : (
        <Box>
          <FormInput
            type="text"
            placeholder="YYYY"
            css={css`
              width: 100%;
            `}
            value={date.year || ''}
            onChange={(e: any) => {
              setDate({ ...date, ['year']: e.target.value });
              setFieldValue(name, `${e.target.value}`).then(() => setFieldTouched(name, true));
            }}
            name="year"
            maxLength="4"
          />
        </Box>
      )}
    </div>
  );
};

export default FormDateGroup;

const query = graphql`
  {
    allTrialsJson {
      nodes {
        path
        strings {
          form {
            title
            formDateGroup {
              month {
                heading
                monthOptions
              }
            }
          }
        }
      }
    }
  }
`;
